<template>
  <SearchBar
    ref="searchBarRef"
    :placeholder="t('admin.users.listing.searchPlaceholder')"
    :value="searchRef"
    :results-position="resultsPosition"
    @emit:change="onSearchChange"
    @emit:clear="onClearSearch"
  >
    <template v-if="searchRef?.length" #searchBarResults>
      <UsersSearchResults
        :filter-by-role="filterByRole"
        :remove-from-results="removeFromResults"
        :search="searchRef"
        :search-bar-ref="searchBarRef"
        :callback="setUserMailToFilter"
        :searchType="searchType"
      />
    </template>
  </SearchBar>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { onMounted } from 'vue'

import type { RoleEnumTypeV2 } from '@/features/auth/types'
import SearchBar from '@/features/ui/components/search-bar/search-bar.vue'
import UsersSearchResults from '@/features/ui/pages/admin/users/users-search/users-search-results/users-search-results.vue'
import type { V2UserAdminDataType } from '@/features/users/types'
import { useI18n } from '@/lib/i18n'

const searchBarRef = ref<any | null>(null)
const searchRef = ref<string | null>(null)

const props = defineProps<{
  searchCallback: () => void
  onMountFocus?: boolean
  filterByRole?: RoleEnumTypeV2
  removeFromResults?: V2UserAdminDataType[]
  resultsPosition?: 'top' | 'bottom'
  searchType?: 'default' | 'sessions'
}>()

const resultsPosition = props.resultsPosition ?? 'bottom'

const { t } = useI18n()

const emit = defineEmits(['emit:result'])

onMounted(() => {
  if (props.onMountFocus) {
    searchBarRef.value.$el.querySelector('input')?.focus()
  }
})

const onClearSearch = () => {
  emit('emit:result', null)
}

const onSearchChange = (value: string) => {
  props.searchCallback()
  searchRef.value = value
  if (value === '') {
    emit('emit:result', null)
  }
}

const setUserMailToFilter = (user: V2UserAdminDataType) => {
  emit('emit:result', user)
  searchRef.value = null
}
</script>
